import { render, staticRenderFns } from "./HelpdeskComponent.vue?vue&type=template&id=b5663e0e"
import script from "./HelpdeskComponent.ts?vue&type=script&lang=ts&external"
export * from "./HelpdeskComponent.ts?vue&type=script&lang=ts&external"
import style0 from "./HelpdeskComponent.vue?vue&type=style&index=0&id=b5663e0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports